import { WobType } from '@/enum/WobType'

export interface IWobCovProgressConstParam  {  
  wobType: string
  irisGdb:any
  migId	:number
  covId :number
  processingStep	:string
  processingState	:string  
  wobDat: string | null
}

export class WobCovProgress {  
  public wobType: WobType
  public irisGdb : any
  public migId: number
  public covId: number
  public processingStep	:string
  public processingState	:string
  public wobDat: Date | null
  

  constructor({ wobType = WobType.WobIrisProcessingPathprogress,irisGdb,migId,covId,processingStep,processingState,wobDat }: IWobCovProgressConstParam = {} as IWobCovProgressConstParam) {
    this.wobType = wobType as WobType
    this.irisGdb = irisGdb
    this.migId = migId
    this.covId = covId
    this.processingStep = processingStep
    this.processingState = processingState
    this.wobDat = wobDat ? new Date(wobDat) : null
  }
}
